import { mutator } from 'satcheljs';
import getStore from '../store/store';
import initializeSettings from './initializeSettings';
import BookingService from 'owa-service/lib/contract/BookingService';

/**
 * Initializes the personal booking page settings in the store.
 */
export default mutator(initializeSettings, actionMessage => {
    let store = getStore();
    store.publishingSettings = actionMessage.pbpSettings.PublishingSettings;
    store.services = new Map<string, BookingService>();
    const service: BookingService = actionMessage.pbpSettings.DefaultService;
    store.services.set(service.ServiceId, service);
    store.servicesOrder = [service.ServiceId];
});
